<template>
  <Card class="setting">
    <template slot="header">
      <div class="header flex align-center justify-between">
        <a class="pointer title mar-r5"> <span>网店助手</span> </a>
        <div class="pointer flex items-center">
          <img src="https://nfs.nxin.com/cms_image_02128766-9b82-470c-b555-b177a4bc8473.png" height="16" @click="contactService" />
          <div class="mar5-l f12 gray3" @click="contactService">联系客服</div>
          <el-popover ref="tradeStoreSwitch" placement="bottom" trigger="click" popper-class="gray6 trade-store-list">
            <ul class="ul-cls">
              <li v-for="item in shopList" :class="{ active: item.isDefault }" :key="item.shopIdStr" @click="updateDefaultShop(item.shopIdStr)">
                {{ item.name }}
              </li>
            </ul>
          </el-popover>
          <el-tooltip content="切换店铺" placement="top">
            <i class="el-icon-s-shop blue mar10-l f22" v-if="shopList.length > 1" v-popover:tradeStoreSwitch></i>
            <!-- <a v-if="shopList.length > 1" class="pointer icon icon0" v-popover:tradeStoreSwitch /> -->
          </el-tooltip>
        </div>
      </div>
    </template>
    <div class="flex pad30 pad0-right h320" :class="{ settingNone: !isClick }" v-loading="loading">
      <div class="flex-auto">
        <ul class="ul-cls flex general-store">
          <template v-for="(item, index) in list">
            <li
              :key="item.type"
              class="flex items-center justify-center flex-column"
              :class="{ 'store-active': switchType == item.type }"
              @click="toAssistantSwitch(item.type, index)"
            >
              <img v-if="isClick" :src="item.img" />
              <img v-else :src="item.imgNo" />
              <div>{{ item.name }}</div>
            </li>
          </template>
        </ul>
        <ul class="mar20-t ul-cls general-step flex">
          <li v-for="(item, index) in list[stepIndex].step" :key="index">
            <div class="f16 fb pad10-b">{{ item.head }}</div>
            <div class="gray9 mar10-b lin25 h50">{{ item.des }}</div>
            <div class="blue pointer" v-if="isClick" @click="$openHome(item.url, item.title, item.target, isClick)">{{ item.clickName }} ></div>
            <div v-else class="flex items-center">
              <el-tooltip placement="bottom" effect="dark" :content="tooltip">
                <i class="el-icon-warning-outline mar5-r pointer"></i>
              </el-tooltip>
              <span>{{ !shopId || defaultShop.audit !== 1 ? "暂无店铺" : "暂无设置权限" }}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="flex justify-center w300 bor-de-left">
        <template v-if="isClick">
          <div class="flex flex-auto flex-column bor_radius_10 shop_info" v-if="shopDtlEntity.shopSort == 'ORDER_GOODS'">
            <div class="flex flex-auto flex-column items-center justify-center padd30">
              <p class="gray_3 f18 mar20-b t_center">{{ shopInfo.name }}</p>
              <div class="flex flex-column flex_ver_center mar10-b">
                <span class="gray_6 f14 flex_1 lin_20 mar10-b">扫码进入小程序，推荐给您的客户，您的客户将在小程序上进行采购</span>
                <img class="wx_code" src="https://filesouthcdn.nxin.com/nxsc_173019846074307706381249643669.JPEG" />
              </div>
              <p class="clear gray_6 f14 lin_20">
                <span class="float-left">主营：</span>
                <span class="float-left ellipsis_two w290">{{ businesScope }}</span>
              </p>
            </div>
          </div>
          <div class="flex flex-auto flex-column shop_info" v-else>
            <div class="flex flex-auto flex-column items-center justify-center padd30">
              <p class="gray_3 f18 mar30_b t_center">{{ shopInfo.name }}</p>
              <div class="flex flex-column items-center justify-center mar10_b" v-if="appletInfo && appletInfo.appId != ''">
                <img class="wx_code" :src="authUrl" />
                <div class="text-center mar10-t">
                  <p class="gray_6 f14">扫码进入小程序，推荐给您的客户</p>
                  <p class="gray_6 f14">您的客户将在小程序上进行采购</p>
                </div>
              </div>
              <div v-else>
                <div class="flex flex_ver_center mar15_b">
                  <span class="gray_6 f14 flex_1 lin_25 t_center">开通企业专属、独立品牌微信小程序</span>
                </div>
                <el-button type="primary" size="medium" @click="toWeiXinPage"> 立即开通 </el-button>
              </div>
            </div>
          </div>
        </template>
        <div class="flex flex-auto flex-column shop_info" v-else>
          <div class="flex flex-auto flex-column items-center justify-center padd30">
            <p class="gray_3 f18 mar30_b t_center">
              {{ !shopId ? "暂无店铺" : defaultShop.name }}
            </p>
            <div class="flex flex_ver_center mar15_b">
              <span class="gray_6 f14 flex_1 lin_25 t_center">开通企业专属、独立品牌微信小程序</span>
            </div>
            <el-tooltip placement="bottom" effect="dark" :content="tooltip">
              <!-- https://sc.nxin.com/shopInfo/approveQY?type=3&reEntered=&againShop=1&appid=1 -->
              <!-- audit 店铺审核状态 0 未审核 1审核通过 2 审核驳回 -->
              <!-- qualificationStatus 店铺资质审核状态 0-未审核 1-审核通过 2-审核驳回 -->
              <el-button type="primary" size="medium" v-if="!shopId && !hideOpenShop" @click="toSetUp">立即开店</el-button>
              <el-button type="warning" size="medium" v-else-if="defaultShop.qualificationStatus === 0" @click="toSetUp">店铺审核中</el-button>
              <el-button type="danger" size="medium" v-else-if="defaultShop.qualificationStatus === 2" @click="toSetUp">店铺被驳回</el-button>
              <el-button type="warning" size="medium" v-else-if="defaultShop.audit === 0" @click="toSetUp">店铺审核中</el-button>
              <el-button type="danger" size="medium" v-else-if="defaultShop.audit === 2" @click="toSetUp">店铺被驳回</el-button>
              <!-- defaultShop.audit === 0 ||  -->
              <!-- <el-button type="info" size="medium" v-else>
                暂无开通权限
              </el-button> -->
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="setupVisible" width="600px" :show-close="false">
      <div class="flex pad20-b">
        <div class="setup" v-for="item in setupList" :key="item.id" @click="setupClick(item.id)">
          <div class="f18 fb gray3">{{ item.title }}</div>
          <div class="f15 gray6 mar10-t">{{ item.des }}</div>
        </div>
      </div>
    </el-dialog>
  </Card>
</template>

<style lang="scss" scoped>
@import "./index.scss";
</style>
<style lang="scss">
.el-loading-spinner .path {
  stroke: #0095f1;
}
.el-popper.trade-store-list {
  border: 1px solid #e9e9e9;
  opacity: 0.9;
  padding: 3px 0;
  ul {
    overflow: auto;
    max-height: 170px;
  }
  li {
    cursor: pointer;
    padding: 0 15px;
    line-height: 34px;
    &.active,
    &:hover {
      color: #fff;
      background-color: #0095f1;
    }
  }
}
</style>

<script>
import { mapState } from "vuex";
import Card from "@/components/Card";

export default {
  components: {
    Card,
    // RealtimeOverview,
  },
  data() {
    return {
      origin: process.env,
      loading: true,
      tooltip: "抱歉，您没有查看权限。若需要查看请联系公司管理员分配权限。",
      shopId: "",
      isClick: true,
      stepIndex: 0,
      list: [
        {
          name: "基础设置",
          type: "JC",
          img: "https://cmscenter-files.nxin.com/nxsc/home/setting/jichu.png",
          imgNo: "https://cmscenter-files.nxin.com/nxsc/home/setting/jichu-no.png",
          step: [
            {
              head: "店铺信息",
              des: "企业简介与视频等基础信息设置",
              clickName: "立即查看",
              url: `${process.env.VUE_APP_APP}v2/shop`,
              title: "店铺信息",
              target: 0,
            },
            {
              head: "支付设置",
              des: "启用微信、支付宝、银行卡等支付",
              clickName: "立即设置",
              url: `${process.env.VUE_APP_APP}mj/toShopFunction?appid=1`,
              title: "系统设置",
              target: 0,
            },
            {
              head: "配送设置",
              des: "设置配送模板、自提地址",
              clickName: "立即设置",
              url: `${process.env.VUE_APP_APP}mj/toOtherAddr.do?appid=1`,
              title: "配送管理",
              target: 0,
            },
            {
              head: "运费设置",
              des: "可设置运费模板，用于商品的运费配置",
              clickName: "立即设置",
              url: `${process.env.VUE_APP_APP}mj/freight/toFreightListEtp.do?appid=1&isDH=1`,
              title: "运费设置",
              target: 0,
            },
            {
              head: "收款账户",
              des: "绑定结算账户，查看资产信息",
              clickName: "去查看",
              url: `${process.env.VUE_APP_HOME}finance/default`,
              title: "收款账户",
              target: 1,
            },
          ],
        },
        {
          name: "商品管理",
          type: "SP",
          img: "https://cmscenter-files.nxin.com/nxsc/home/setting/huopin.png",
          imgNo: "https://cmscenter-files.nxin.com/nxsc/home/setting/huopin-no.png",
          step: [
            {
              head: "商品设置",
              des: "商品的新增、编辑、上下架等管理",
              clickName: "立即设置",
              url: `${process.env.VUE_APP_APP}mj/toGoodsMJ.do?appid=1`,
              title: "货品管理",
              target: 0,
            },
            {
              head: "分类管理",
              des: "设置商品分类及分类图标等信息",
              clickName: "立即设置",
              url: `${process.env.VUE_APP_APP}classify/toShopClassify.do?appid=1`,
              title: "商品分类管理",
              target: 0,
            },
          ],
        },
        {
          name: "客户管理",
          type: "KH",
          img: "https://cmscenter-files.nxin.com/nxsc/home/setting/kehu.png",
          imgNo: "https://cmscenter-files.nxin.com/nxsc/home/setting/kehu-no.png",
          step: [
            {
              head: "客户列表",
              des: "店铺老客户展示、新客户引入、客户所属分组等设置",
              clickName: "立即设置",
              url: `${process.env.VUE_APP_APP}mj/customer/toCustomerNew.do?appid=1`,
              title: "客户列表",
              target: 0,
            },
            {
              head: "客户分组",
              des: "设置客户的分组信息，用于客户分层管理",
              clickName: "立即设置",
              url: `${process.env.VUE_APP_APP}mj/customer/toCustomerGroup.do?appid=1`,
              title: "客户分组",
              target: 0,
            },
            {
              head: "价格方案",
              des: "针对不同客户设置不同的商品价格设置",
              clickName: "立即设置",
              url: `${process.env.VUE_APP_APP}mj/priceScheme/toPriceListPage.do?appid=1`,
              title: "价格方案",
              target: 0,
            },
          ],
        },
        {
          name: "销售管理",
          type: "XS",
          img: "https://cmscenter-files.nxin.com/nxsc/home/setting/xiaoshou.png",
          imgNo: "https://cmscenter-files.nxin.com/nxsc/home/setting/xiaoshou-no.png",
          step: [
            {
              head: "销售订单",
              des: "查看销售订单明细、详情，对订单进行发货、售后的处理",
              clickName: "立即设置",
              url: `${process.env.VUE_APP_APP}v/order/seller/list?appid=1&isShowTitle=1`,
              title: "订单管理",
              target: 0,
            },
            {
              head: "销售汇总",
              des: "按商品、客户两个维度汇总展示销售数据",
              clickName: "立即设置",
              url: `${process.env.VUE_APP_APP}v/mj/sellCollect?isShowTitle=1&appid=1`,
              title: "销售汇总表",
              target: 0,
            },
            {
              head: "对账单",
              des: "查看订单商品的收款对账信息",
              clickName: "立即查看",
              url: `${process.env.VUE_APP_APP}mj/bill/page.do?appid=1`,
              title: "销售对账单",
              target: 0,
            },
          ],
        },
      ],
      marketing: {
        name: "营销管理",
        type: "yx",
        img: "https://cmscenter-files.nxin.com/nxsc/home/setting/yingxiao.png",
        imgNo: "https://cmscenter-files.nxin.com/nxsc/home/setting/yingxiao-no.png",
        step: [
          {
            head: "广告设置",
            des: "设置首页的轮播广告和商品推荐",
            clickName: "立即设置",
            url: `${process.env.VUE_APP_APP}index/toIndexCarouselFiguer.do?appid=1`,
            title: "首页装修",
            target: 0,
          },
          {
            head: "优惠券管理",
            des: "添加设置优惠券活动",
            clickName: "立即创建",
            url: `${process.env.VUE_APP_APP}mj/coupon/toShopCoupon.do?appid=1`,
            title: "优惠券管理",
            target: 0,
          },
          {
            head: "促销管理",
            des: "店铺设置促销活动（包括直降、折扣、买赠等活动）,吸引顾客进店购买",
            clickName: "立即创建",
            url: `${process.env.VUE_APP_APP}v/mj/promotion/list?appid=1&isShowTitle=1`,
            title: "促销管理",
            target: 0,
          },
        ],
      },
      tableData: [],
      shopInfo: {},
      businesScope: "",
      switchType: "JC",
      shopDtlEntity: {},
      appletInfo: null,
      authUrl: "",
      isOpenType: 0,
      setupVisible: false,
      setupList: [
        {
          id: 1,
          title: "电商版（推荐）",
          des: "入驻农信商城，享受平台流量，品牌加持，货卖全国",
        },
        {
          id: 2,
          title: "订货版",
          des: "企业私域订货系统，一键开通，客户直接线上订货",
        },
      ],
      // 是否展示开店
      hideOpenShop: false,
    };
  },
  computed: mapState({
    shopList: (state) => state.app.shopList,
    showTitle: (state) => state.app.showTitle,
    defaultShop: (state) => state.app.defaultShop,
    salesAuthority: (state) => state.app.salesAuthority,
  }),
  mounted() {
    console.log("defaultShop", this.defaultShop);
    this.$store.dispatch("orderHome/index/checkManagePermission", "gyy").then((res) => {
      this.loading = false;
      console.log("checkManagePermission.res: ", res);
      if (!res.data) {
        this.hideOpenShop = true;
      }
    });
    // shopDtlEntity.shopSort == 'MICRO_STORE'
    const { shopIdStr, audit, qualificationStatus } = this.defaultShop;
    this.shopId = shopIdStr || "";

    if (!this.salesAuthority) {
      this.isClick = false;
      this.loading = false;
      return;
    }
    if (!shopIdStr || audit !== 1 || qualificationStatus !== 1) {
      this.tooltip = "抱歉，您暂未开店或店铺正在审核中,请先开店或等待店铺审成功后再试。";
      if (qualificationStatus === 2) {
        this.tooltip = "店铺资质审核被驳回，请重新提交审核";
      }
      this.isClick = false;
      this.loading = false;
      return;
    }

    // audit  0初始未审核、1审核已通过、2审核未通过、4已关闭
    this.$store.dispatch("orderHome/index/getQuerySingleShop").then((res) => {
      this.loading = false;
      if (res.data) {
        this.loadTrue = true;
        this.shopInfo = res.data;
        this.$store.dispatch("shop/shop/queryShopDtlByBoId").then((data) => {
          if (data.data) {
            this.shopDtlEntity = data.data.shopDtlEntity;
            if (this.shopDtlEntity.shopSort == "MICRO_STORE") {
              this.list.push(this.marketing);
            }
          }
        });
        this.$store.dispatch("applet/applet/getShopAppletInfo", { isRelease: 1 }).then((applet) => {
          if (applet) {
            this.appletInfo = applet;
            if (this.appletInfo.appId !== "") {
              this.$store.dispatch("applet/applet/getQrcodeUrl", { ucAppId: this.appletInfo.appId }).then((authUrl) => {
                if (authUrl && authUrl.data) {
                  this.authUrl = authUrl.data;
                }
              });
            }
          }
        });
        this.businesScope = this.shopInfo.businesScope ? this.shopInfo.businesScope.replace(",", " | ") : ""; //eslint-disable-line
      }
    });
  },

  methods: {
    // 联系客服
    contactService() {
      window.open("https://work.weixin.qq.com/kfid/kfcd200d8c554673e56");
    },
    // 切换店铺
    updateDefaultShop(id) {
      this.$store.dispatch("trade/updateDefaultShop", { shop_id: id }).then((res) => {
        if (!res.code) {
          this.$message({
            type: "success",
            message: "更新默认店铺成功",
            duration: 1000,
            onClose() {
              if (window.self !== window.top) {
                window.parent.postMessage(
                  {
                    fn: "reload",
                  },
                  "*"
                );
              } else {
                window.location.reload(true);
              }
            },
          });
        }
      });
    },
    // 助手切换
    toAssistantSwitch(type, index) {
      this.switchType = type;
      this.stepIndex = index;
    },

    toWeiXinPage() {
      if (this.shopDtlEntity.shopSort === "PUBLIC") {
        // const h = this.$createElement;
        this.$message({
          dangerouslyUseHTMLString: true,
          message: "<div class='lin_20'>若需开通服务，请联系客服人员！</div><div class='lin_20'>客服电话:18600502193(同微信号)</div>",
          type: "warning",
        });
      } else {
        window.top.postMessage(
          {
            fn: "open",
            data: {
              url: `${process.env.VUE_APP_APP}v/miniProgram`,
              title: "微信小程序管理",
              target: 0,
            },
          },
          "*"
        );
      }
    },
    toSetUp() {
      this.setupVisible = true;
    },
    setupClick(id) {
      const setup = id === 2 ? "/orderSystem/dhShop" : "/setup";
      // this.$router.push(setup);
      const url = `${process.env.VUE_APP_APP}v${setup}`;
      this.setupVisible = false;
      window.top.postMessage({ fn: "open", data: { url, title: "免费开店", target: 0 } }, "*");
    },
  },
};
</script>
